import STORAGE from './Storage';

export default class SessionStorage<T> extends STORAGE<T> {
  get storage() {
    return typeof window === 'undefined' ? null : window.sessionStorage;
  }
}
